export const theme = Object.freeze({
  DEFAULT: "DEFAULT",
  DARK: "DARK",
});